export const ADD_TAXES = 'ADD_TAXES'
export const ADD_TAXE = 'ADD_TAXE'
export const ADD_TAXE_TYPE_ENUM = 'ADD_TAXE_TYPE_ENUM'
